import { render, staticRenderFns } from "./immigrant_declaration.vue?vue&type=template&id=e93cdac8&"
import script from "./immigrant_declaration.vue?vue&type=script&lang=js&"
export * from "./immigrant_declaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports